export default __webpack_public_path__ + "static/media/7c2bc884d57ffd06.712815c135de233e04c7b09345798a6c.svg";